export default __webpack_public_path__ + "static/media/goshen46.f4fc2559.jpg";